// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"270":"d4803c44","326":"85f83a56"}[chunkId] + ".css";
};